import { SecretManagerServiceClient } from "@google-cloud/secret-manager";
import { initializeApp } from "firebase/app";
import {
  getDatabase,
  ref,
  set,
  get,
  push,
  onValue,
  onDisconnect,
} from "firebase/database";
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";

class Firebase {
  constructor() {
    // this.client = new SecretManagerServiceClient();
    this.initFirebase();
  }

  async initFirebase() {
    // console.log(process.env["API_KEY"]);
    // const API_KEY = await this.getSecret("API_KEY");
    // console.log("API_KEY: ", API_KEY);
    // const APP_ID = await this.getSecret("APP_ID");
    // console.log("APP_ID: ", APP_ID);
    // const MESSENGER_SENDING_ID = await this.getSecret("MESSENGER_SENDING_ID");
    // console.log("MESSENGER_SENDING_ID: ", MESSENGER_SENDING_ID);

    let firebaseConfig = {
      apiKey: process.env.API_KEY,
      authDomain: process.env.AUTH_DOMAIN,
      databaseURL: process.env.DB_URL,
      projectId: process.env.PROJECT_ID,
      storageBucket: process.env.STORAGE_BUCKET,
      messagingSenderId: process.env.MESSENGER_SENDING_ID,
      appId: process.env.APP_ID,
    };

    this.APP = initializeApp(firebaseConfig);
    const auth = getAuth();

    onAuthStateChanged(auth, (user) => {
      if (user) {
        this.isAnonymous = user.isAnonymous;
        this.uid = user.uid;
      }
    });

    signInAnonymously(auth)
      .then(() => {
        console.log("User signed in anonymously");
      })
      .catch((error) => {
        let errorCode = error.code;
        let errorMessage = error.message;
        console.log(errorCode, errorMessage);
      });

    this.DB = getDatabase();
    // this.DB.INTERNAL.forceWebSockets();
  }

  async getSecret(name) {
    // you can get more sophistacted here with different environments but that wasn't needed for my case
    if (process.env.NODE_ENV === "production") {
      console.log("production");
      // // if your project my-cool-project, the secret name is 'projects/my-cool-project/...'
      // const real_name = `projects/cilex-puzzle/secrets/${name}/versions/latest`;
      // const [secret] = await this.client.accessSecretVersion({
      //   name: real_name,
      // });
      // return Buffer.from(secret.payload.data).toString();
      return fetch(`gets/${name}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      })
        .then((response) => response.text())
        .then((txt) => txt);
    } else {
      console.log(typeof name);
      const test = process.env[`${name}`];
      console.log("development", name, test);
      // because they're in your .env

      return process.env[name];
    }
  }

  send(_path, _val) {
    const path = ref(this.DB, _path);
    set(path, _val);
  }

  directPush(_path, _val) {
    const path = ref(this.DB, _path);
    push(path, _val);
  }

  listen(_path, _callback) {
    const path = ref(this.DB, _path);
    onValue(path, (snapshot) => {
      // const data = snapshot.val();
      _callback(snapshot);
    });
  }

  listenOnce(_path, _callback) {
    const path = ref(this.DB, _path);
    get(path).then((snapshot) => {
      _callback(snapshot);
    });
  }

  disconnect(_path) {
    const path = ref(this.DB, _path);
    onDisconnect(path).set(null);
  }

  reset(_path) {
    const path = ref(this.DB, _path);
    set(path, null);
  }
}

export default new Firebase();
